import Schedule from '@mui/icons-material/Schedule'
import DateRangeIcon from '@mui/icons-material/DateRange'
import MeetingRoomIcon from '@mui/icons-material/MeetingRoom'
import WarningAmberIcon from '@mui/icons-material/WarningAmber'
import WavingHandIcon from '@mui/icons-material/WavingHand'
import { Chip, useTheme } from '@mui/material'

import { getInvoiceSubStatus, getInvoiceSubStatusColors, isInvoiceCanceled } from '@shared/invoices'
import type { CustomOrderAdminDto, InvoiceAdminDto } from 'service-api/src/types/api'

export const InvoiceStatus = ({ invoice, order }: { invoice: InvoiceAdminDto; order?: CustomOrderAdminDto }) => {
  const theme = useTheme()
  const isCanceled = isInvoiceCanceled(invoice)
  const subStatus = getInvoiceSubStatus(invoice)
  const isProcessing = subStatus.isPending && !!order?.payments?.some((p) => p.step === 'CONFIRMED')
  const { backgroundColor, color } = getInvoiceSubStatusColors(theme, invoice, { isProcessing })
  const cssCommon = {
    fontWeight: 600,
    padding: '4px 8px',
    borderRadius: '8px',
    ...(backgroundColor ? { backgroundColor } : {}),
    ...(color ? { color, '& svg': { fill: color } } : {}),
  }

  if (subStatus.isDeclined) {
    return <Chip label="DECLINED" sx={cssCommon} />
  }

  if (isCanceled) {
    return <Chip label="CANCELED" sx={cssCommon} />
  }

  if (isProcessing) {
    return <Chip label="PROCESSING" icon={<Schedule />} sx={cssCommon} />
  }

  if (subStatus.isPending) {
    return <Chip label="UNCONFIRMED" icon={<WarningAmberIcon />} sx={cssCommon} />
  }

  if (subStatus.isBooked) {
    return <Chip label="BOOKED" icon={<DateRangeIcon />} sx={cssCommon} />
  }

  if (subStatus.isInProgress) {
    return <Chip label="CHECKED IN" icon={<MeetingRoomIcon />} sx={cssCommon} />
  }

  if (subStatus.isScheduled) {
    return <Chip label="SCHEDULED" icon={<DateRangeIcon />} sx={cssCommon} />
  }

  if (subStatus.isSold) {
    return <Chip label="SOLD" sx={cssCommon} />
  }

  if (subStatus.isCheckedOut) {
    return <Chip label="CHECKED OUT" icon={<WavingHandIcon />} sx={cssCommon} />
  }

  if (subStatus.isRequested) {
    return <Chip label="REQUESTED" icon={<WarningAmberIcon />} sx={cssCommon} />
  }

  return null
}
